import Common from '../../Common';

const WallboardOutgoing = class extends Common {
	readData = (id: id, wallboardToken: string) =>
		this.get(`/user/wallboardoutgoing/${id}?wallboard_token=${wallboardToken}`)
}

export default WallboardOutgoing
